var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', _vm._g({
    staticClass: "app-header-back-btn",
    class: _vm.buttonClasses,
    attrs: {
      "icon": "",
      "aria-label": _vm.label
    }
  }, _vm.$listeners), [_c('v-icon', {
    attrs: {
      "color": "#6058c8"
    }
  }, [_vm._v("mdi-arrow-left")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }